/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../widget/renderSequence/api/RenderStepProviderAPI',
	'../../../visualizations/renderer/sequence/BaseTask'
], function(
	APIFactory,
	RenderStepProviderAPI,
	BaseTask
) {
	/**
	 * Metadata render sequence task to ensure the datasource is loaded prior to rendering a visualization
	 */
	class MetadataTask extends BaseTask {
		process(renderContext) {
			// avoid attempting to load the metadata if it's already loaded
			if (this._isStepComplete(renderContext, 'metadata')) {
				return Promise.resolve(renderContext);
			}

			const visualization = this.content.getFeature('Visualization');
			const datasource = visualization.getDataSource();

			return datasource ? datasource.loadMetadata().then(() => {
				this.validateLocalFilters();
				this._completeStep(renderContext, 'metadata', datasource);
			}).catch((e) => {
				this.logger.log('An error occured while loading the metadata for content with id ' + this.content.getId());
				this.logger.log(e);
				throw new Error('dwErrorMissingDataset');
			}) : Promise.resolve();
		}

		validateLocalFilters() {
			const visualization = this.content.getFeature('Visualization.internal');
			visualization.validateLocalFilters();
		}
	}

	/**
	 * Metadata render sequence task provider
	 */
	class MetadataTaskProvider {
		constructor({ features }) {
			this.api = APIFactory.createAPI(this, [RenderStepProviderAPI]);
			features.RenderSequence.registerRenderStepProvider(this.getAPI());
		}

		getAPI() {
			return this.api;
		}

		getRenderStepList() {
			return [{
				id: 'metadata',
				dependencies:[],
				blocks:['visControl'],	//Should be 'data'
				module: MetadataTask
			}];
		}
	}

	return MetadataTaskProvider;
});
